export function isLoggedInUser(currentUser) {
    return !!currentUser;
}
